export default __webpack_public_path__ + "static/angularjs-clipboard-55099334d99ace3adb6ed7db36c37905.png";